export enum OrganizationSource {
  ALKEMICS = 0,
  PRODUCTDNA = 1,
}
